import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { get } from "lodash";

import AsyncGet from '../../../components/Materials/AsyncGet';
import Spinner from "../../../components/Spinner";
import { trackView } from "../../../helpers/analytics";

import style from './style.module.css';

const Guest = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    useEffect(() => {
        trackView(pathname);
    }, [pathname]);
    return (
        <AsyncGet
            url="/account"
            loadOnMount={true}
            onFetch={({ data }) => {
                if (get(data, 'id')) {
                    navigate('/dashboard');
                }
            }}
            showToastOnError={false}
            permissionText={false}
            render={({ fetching, loaded }) => {
                return (
                    <div className={style.layoutWrap}>
                        <div className={`${style.content} ${style.full}`}>
                            {loaded === false && fetching === true &&
                                <Spinner size="large" className={style.loader} color='var(--secondaryColor)' />
                            }
                            {loaded === true && fetching === false &&
                                <Outlet />
                            }
                        </div>
                    </div>
                )
            }}
        />
    )
}
export default Guest;